<template>
	<div style="display: inline-block">
		<b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-info" @click="onCondivisioneClick()">
			<b-icon icon="share" variant="outline-primary" />
		</b-button>

		<b-modal ref="mdlCondivisione" size="xl" title="Utenti" modal-class="sa-modal-table" style="height: 100%; overflow-y: hidden" scrollable>
			<b-tabs v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill>
				<b-tab title="Gruppi">
					<div class="b-table-sticky-header">
						<b-table sticky-header ref="tblCondivisioneGruppo" id="tblCondivisioneGruppo" stacked="lg" striped hover :items="itemsGruppi" :fields="fieldsGruppi" sort-icon-left head-variant="light" class="sa-b-table">
							<!-- <template v-slot:cell(cognomenome)="{ item }">
								<span>{{ item.nome }} {{ item.firstname }} ({{ item.username }})</span>
							</template> -->
							<template v-slot:cell(statocondivisione)="{ item }">
								<b-form-checkbox :checked="isActive(item.idSezione, item.idRisorsa)" switch @change="onChangeCondivisioneGruppo(item)">
									<span v-if="item.scadenzaCondivisione">
										Fino al:
										<b>{{ getScadenzaCondivisione(item.scadenzaCondivisione) }}</b>
									</span>
								</b-form-checkbox>
							</template>
							<template v-slot:cell(permessi)="{ item }">
								<div v-for="(permesso, index) in permessiAssegnati(item)" :key="index">
									<b-form-checkbox :disabled="!isActive(item.idSezione, item.idRisorsa)" v-model="permesso.attivo" size="md" switch class="sa-normal-label" @change="onChangeAddPermessoGruppo(permesso, item)">{{ permesso.descrizione }}</b-form-checkbox>
								</div>
							</template>
						</b-table>
					</div>
				</b-tab>
				<b-tab title="Utenti">
					<div class="b-table-sticky-header">
						<b-table sticky-header ref="tblCondivisione" id="tblCondivisione" stacked="lg" striped hover :items="items" :fields="fields" sort-icon-left head-variant="light" class="sa-b-table">
							<template v-slot:cell(cognomenome)="{ item }">
								<span>{{ item.lastname }} {{ item.firstname }} ({{ item.username }})</span>
							</template>
							<template v-slot:cell(statocondivisione)="{ item }">
								<b-form-checkbox :checked="isActive(item.idSezione, item.idRisorsa)" switch @change="onChangeCondivisione(item)">
									<span v-if="item.scadenzaCondivisione">
										Fino al:
										<b>{{ getScadenzaCondivisione(item.scadenzaCondivisione) }}</b>
									</span>
								</b-form-checkbox>
							</template>
							<template v-slot:cell(permessi)="{ item }">
								<div v-for="(permesso, index) in permessiAssegnati(item)" :key="index">
									<b-form-checkbox :disabled="!isActive(item.idSezione, item.idRisorsa)" v-model="permesso.attivo" size="md" switch class="sa-normal-label" @change="onChangeAddPermessoUtente(permesso, item)">{{ permesso.descrizione }}</b-form-checkbox>
								</div>
							</template>
						</b-table>
					</div>
				</b-tab>
			</b-tabs>

			<template #modal-footer>
				<b-row>
					<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
						<b-button size="sm" variant="danger" @click="onCloseClick()">Chiudi</b-button>
					</b-col>
				</b-row>
			</template>
		</b-modal>
	</div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../UtilityMixin";
export default {
	mixins: [UtilityMixin],
	props: {
		idRisorsa: {
			type: String,
			required: true,
		},
		idSezione: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			activeTabIndex: 0,
			pathResource: "/condivisione",
			pathResourceGruppi: "/condivisione/gruppi",
			pathResourceSezioni: "/sezioni",
			itemsGruppi: [],
			items: [],
			fields: [
				{
					label: "Cognome e Nome",
					key: "cognomenome",
					sortable: true,
				},
				{
					label: "Profilo",
					key: "profilo",
					sortable: true,
					thStyle: "width: 18rem",
				},
				{
					label: "Stato Cond.",
					key: "statocondivisione",
					thStyle: "width: 6rem",
				},
				{
					label: "Permessi",
					key: "permessi",
					thStyle: "width: 18rem",
				},
			],
			fieldsGruppi: [
				{
					label: "Nome Gruppo",
					key: "nome",
					sortable: true,
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
					thStyle: "width: 18rem",
				},
				{
					label: "Stato Cond.",
					key: "statocondivisione",
					thStyle: "width: 6rem",
				},
				{
					label: "Permessi",
					key: "permessi",
					thStyle: "width: 18rem",
				},
			],
		};
	},
	computed: {
		verificaPermesso() {
			return true;
		},
	},
	methods: {
		permessiAssegnati(item) {
			let returnValue = [];

			this.sezione.permessi.forEach((element) => {
				element.attivo = false;
				if (item.permessiCondivisione) {
					if ((item.permessiCondivisione & element.permesso) != 0) {
						element.attivo = true;
					}
				}
				returnValue.push(element);
			});

			return returnValue;
		},
		loadSezioni() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceSezioni + "/" + this.idSezione;
			axios.get(link).then((response) => {
				me.sezione = response.data.data;
				this.loadCondivisioni();
				this.loadCondivisioniGruppi();
				me.$refs.mdlCondivisione.show();
			});
		},
		loadCondivisioniGruppi() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceGruppi;
			let queryParams = { idSezione: me.idSezione, idRisorsa: me.idRisorsa };
			axios.get(link, { params: queryParams }).then((response) => {
				me.itemsGruppi = [];
				me.itemsGruppi = response.data.data;
				me.$refs.mdlCondivisione.show();
			});
		},
		loadCondivisioni() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource;
			let queryParams = { idSezione: me.idSezione, idRisorsa: me.idRisorsa };
			axios.get(link, { params: queryParams }).then((response) => {
				me.items = [];
				me.items = response.data.data;
				me.$refs.mdlCondivisione.show();
			});
		},
		onCloseClick() {
			let me = this;
			me.$refs.mdlCondivisione.hide();
		},
		onCondivisioneClick() {
			this.loadSezioni();
		},
		isActive(idSezione) {
			let returnValue = idSezione ? true : false;
			return returnValue;
		},
		getScadenzaCondivisione(scadenzaCondivisione) {
			return UtilityMixin.methods.formatDateTime(scadenzaCondivisione);
		},
		onChangeCondivisione(item) {
			let me = this;
			if (!item.idRisorsa) {
				me.creaCondivisione(item.username);
			} else {
				me.rimuoviCondivisione(item);
			}
		},
		onChangeCondivisioneGruppo(item) {
			let me = this;
			if (!item.idRisorsa) {
				me.creaCondivisione(item.nome);
			} else {
				me.rimuoviCondivisione(item);
			}
		},
		creaCondivisione(usernameGruppoUtenteCondivisore) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource;
			let params = { usernameGruppoUtenteCondivisore: usernameGruppoUtenteCondivisore, idRisorsa: me.idRisorsa, idSezione: me.idSezione };
			axios.post(link, params)
				.then(() => {
					this.loadCondivisioni();
					this.loadCondivisioniGruppi();
				})
				.catch((error) => {
					console.log(error);
					me.$bvToast.toast("Errore durante il la condivisione", {
						title: "Errore",
						variant: "danger",
						solid: true,
					});
				});
		},
		aggiornaCondivisione(item, usernameGruppoUtenteCondivisore) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + item.id;
			let params = { usernameGruppoUtenteCondivisore: usernameGruppoUtenteCondivisore, idRisorsa: me.idRisorsa, idSezione: me.idSezione, permessiCondivisione: item.permessiCondivisione };
			axios.put(link, params)
				.then(() => {
					this.loadCondivisioniGruppi();
				})
				.catch((error) => {
					console.log(error);
					me.$bvToast.toast("Errore durante il la condivisione", {
						title: "Errore",
						variant: "danger",
						solid: true,
					});
				});
		},
		rimuoviCondivisione(item) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + item.id;
			axios.delete(link)
				.then(() => {
					me.loadCondivisioni();
					this.loadCondivisioniGruppi();
				})
				.catch((error) => {
					console.log(error);
					me.$bvToast.toast("Errore durante la rimozione della condivisione", {
						title: "Errore",
						variant: "danger",
						solid: true,
					});
				});
		},
		onChangeAddPermessoGruppo(permesso, item) {
			if (permesso.attivo) {
				item.permessiCondivisione = item.permessiCondivisione + permesso.permesso;
			} else {
				item.permessiCondivisione = item.permessiCondivisione - permesso.permesso;
			}
			this.aggiornaCondivisione(item, item.nome);
		},
		onChangeAddPermessoUtente(permesso, item) {
			if (permesso.attivo) {
				item.permessiCondivisione = item.permessiCondivisione + permesso.permesso;
			} else {
				item.permessiCondivisione = item.permessiCondivisione - permesso.permesso;
			}
			this.aggiornaCondivisione(item, item.username);
		},
	},
};
</script>

<style></style>
